<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import General from '@/services/General';
    import Customers from '@/services/Customers';
    import validationMessages from '@/components/validations'
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";

    const DEFAULT_COMPANY_BACKGROUND_COLOR = "#e8edf2";

    export default {
        components:{
            validationMessages,
            Multiselect,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                name: '',
                description: '',
                website: '',
                email: '',
                company_image : '' ,
                logo_url : '' ,
                background_color : DEFAULT_COMPANY_BACKGROUND_COLOR ,
                external_company_id : '',
                photoDeletedCompanyImage : false ,
                photoDeletedLogoUrl : false ,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
                maxCharsDescription: 65500,
                maxCharsName:128,
                external_companies: null,
                select_external_company: '',
                availableLabels: [],
                selectedLabels: [],

                dropzoneOptions_primary: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 4,
                    acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
                    maxFiles: 3,
                },
            };
        },
        validations: {
            name: {
                required
            },
            description: {
                required
            },
            // logo_url:{
            //     required
            // }
        },
        computed:{
            remainingChars() {
                return this.maxCharsDescription - this.description.length;
            },
            remainingCharsName() {
                return this.maxCharsName - this.name.length;
            }
        },
        methods: {

            async addCompany(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {
                        const formData = new FormData();
                        formData.append("name", this.name);
                        formData.append("description", this.description);
                        formData.append("website", this.website || "");
                        formData.append("email", this.email || "");
                        formData.append(
                            "background_color",
                            this.background_color || DEFAULT_COMPANY_BACKGROUND_COLOR
                        );
                        formData.append("external_company_id", this.external_company_id || "");
                        formData.append("active", this.verified_checked ? "1" : "");
                        formData.append("csrf_token", this.csrf_token);

                        if (this.logo_url) {
                            const file = this.logo_url.file || this.logo_url;
                            formData.append("logo_url", file);
                        }

                        this.selectedLabels.forEach((label) => {
                            formData.append("label_ids[]", label.id);
                        });

                        await Customers.addCompany(formData).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },

            async getExternalCompanies(){
                try {
                    const response = await Customers.getExternalCompanies('exclude_attached=true')
                    this.external_companies = response.data.data
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.companies = null
                }
            },
            async fetchCompanyLabels() {
                try {
                    const response = await Customers.getCustomersLabel({
                        is_business_label: 1,
                        active: 1,
                    });
                    this.availableLabels = response.data.data || [];
                } catch (error) {
                    this.availableLabels = [];
                }
            },
            labelBadgeStyle(label) {
                const bg = label.color || "#6c757d";
                return {
                    backgroundColor: bg,
                    color: this.labelTextColor(bg),
                };
            },
            labelTextColor(hex) {
                if (!hex) {
                    return "#fff";
                }
                const color = hex.replace("#", "");
                if (color.length !== 6) {
                    return "#fff";
                }
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return luminance > 0.6 ? "#212529" : "#fff";
            },
            async onModalShown() {
                await Promise.all([this.getExternalCompanies(), this.fetchCompanyLabels()]);
            },

            onExternalCompanyChange(){
              //console.log(this.select_external_company);
                this.name = this.select_external_company.name
                this.description = this.select_external_company.description
                this.website = this.select_external_company.website
                this.email = this.select_external_company.email
                this.external_company_id = this.select_external_company.external_company_id
            },

            selectFileLogoUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_logo_url.getQueuedFiles();
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only have one logo url');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_logo_url.removeFile(value);
                        });
                    }
                    this.logo_url = queuedFiles[0];
                    this.photoDeletedLogoUrl = false;
                }, 250);
            },
            refreshData() {
                this.$emit('onRefresh')
            },
            closeModal() {
                this.showModal = false
                this.resetProps()
            },
            resetProps(){
                this.name = this.description = this.website = this.email = this.select_external_company = ''
                this.background_color = DEFAULT_COMPANY_BACKGROUND_COLOR
                this.selectedLabels = [];
                this.availableLabels = [];
                this.submitted = false
            }
        },
    };
</script>

<template>
    <b-modal v-model="showModal" @hidden="resetProps" @shown="onModalShown" id="add_new_company" title=" Add new Company" title-class="font-18" size="lg" centered>
        <form @submit.prevent="addCompany">
            <div class="row">
                <div class="col">

                    <b-form-group label-for="formrow-external-input" class="mb-3">
                      <label for="name">Pull Company From External Source</label>
                      <small class="text-muted">
                        (*optional)
                      </small>
                      <select v-model="select_external_company" class="form-select" @change="onExternalCompanyChange">
                        <option disabled value="">-- Select a Company From External Source --</option>
                        <option v-for="(external_company, index) in external_companies" :key="index" :value="external_company">{{external_company.name}}</option>
                      </select>
                    </b-form-group>

                    <hr>

                    <b-form-group  label-for="formrow-name-input" class="mb-3">
                        <label for="name">Company Name</label> <small class="text-muted">
                        (Max {{ remainingCharsName }} characters)
                    </small>
                        <b-form-input
                                v-model.trim="name"
                                :maxlength="maxCharsName"
                                type="text"
                                id="name"
                                aria-describedby="name-feedback"
                                :class="{
                                  'is-invalid': submitted && $v.name.$error,
                                }"
                        >
                        </b-form-input>
                        <validationMessages v-if="submitted" :fieldName="'Company Name'" :validationName="$v.name"></validationMessages>
                    </b-form-group>

                    <b-form-group  label-for="formrow-description-input" class="mb-3">
                        <label for="description">Description</label> <small class="text-muted">
                        (Max {{ remainingChars }} characters)
                    </small>
                    <b-form-textarea
                            style="height: 150px;"
                            v-model.trim="description"
                            :maxlength="maxCharsDescription"
                            type="text"
                            id="description"
                            aria-describedby="description-feedback"
                            :class="{
                              'is-invalid': submitted && $v.description.$error,
                            }"
                    >
                    </b-form-textarea>

                        <validationMessages v-if="submitted" :fieldName="'Description'" :validationName="$v.description"></validationMessages>
                    </b-form-group>

                    <b-form-group label="Background color" label-for="formrow-background-color" class="mb-3">
                        <small class="text-muted d-block mb-1">(*optional — defaults to light blue-gray if not changed)</small>
                        <b-form-input
                                v-model.trim="background_color"
                                type="color"
                                id="background_color"
                                aria-describedby="background-color-feedback"
                                class="form-control form-control-color"
                        >
                        </b-form-input>
                    </b-form-group>


                    <b-form-group label="Website" label-for="formrow-website-input" >
                        <b-form-input
                                v-model.trim="website"
                                type="text"
                                id="website"
                                aria-describedby="website-feedback"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group label="Email" label-for="formrow-email-input" >
                      <b-form-input
                          v-model.trim="email"
                          type="text"
                          id="email"
                          aria-describedby="email-feedback"
                      >
                      </b-form-input>
                    </b-form-group>

                    <b-form-group label="Labels" label-for="company-labels" class="mb-3">
                        <multiselect
                            id="company-labels"
                            class="label-multiselect"
                            v-model="selectedLabels"
                            :options="availableLabels"
                            :multiple="true"
                            :close-on-select="false"
                            label="name"
                            track-by="id"
                            placeholder="Select labels"
                        >
                            <template slot="option" slot-scope="{ option }">
                                <span
                                    class="label-option-swatch me-2"
                                    :style="{ backgroundColor: option.color || '#6c757d' }"
                                />
                                <span>{{ option.name }}</span>
                            </template>
                            <template slot="tag" slot-scope="{ option, remove }">
                                <span class="multiselect__tag label-multiselect-tag" :style="labelBadgeStyle(option)">
                                    {{ option.name }}
                                    <i class="multiselect__tag-icon" @click="remove(option)" aria-hidden="true"></i>
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>

                </div>

                <b-form-checkbox-group>
                    <div class="form-check form-switch form-switch-lg mb-3" >
                        <label class="form-check-label" for="companyStatus">Active</label>
                        <input v-model="verified_checked"
                               type="checkbox"
                               class="form-check-input"
                               id="companyStatus"
                        />
                    </div>
                </b-form-checkbox-group>


                <hr>
                <hr>
                <div class="form-group " >
                    <label for="logo_url">Logo Image: (Max size:4 MB)</label>
                    <template>
                        <vue-dropzone
                                id="logo_url"
                                ref="myVueDropzone_logo_url"
                                :use-custom-slot="true"
                                :options="dropzoneOptions_primary"
                                @vdropzone-files-added="selectFileLogoUrl"
                                no-progress-bar
                        >
                            <div class="dropzone-custom-content">
                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                <h4>Drop file here or click to upload.</h4>
                            </div>
                        </vue-dropzone>
                    </template>
                    <validationMessages v-if="submitted" :fieldName="'Company Logo'" :validationName="$v.logo_url"></validationMessages>

                </div>


                <div class="col">

                    <hr>
                </div>
            </div>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addCompany" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
        </template>
    </b-modal>
</template>

<style scoped>
.label-option-swatch {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    vertical-align: middle;
}

</style>